import { render, staticRenderFns } from "./cooperation-accounts-detail.vue?vue&type=template&id=ef2e2dda&scoped=true&"
import script from "./cooperation-accounts-detail.vue?vue&type=script&lang=js&"
export * from "./cooperation-accounts-detail.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-accounts-detail.vue?vue&type=style&index=0&id=ef2e2dda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2e2dda",
  null
  
)

export default component.exports